import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";

const CARD_WIDTH = { M: 360, L: 480 };

const CustomCardComponent = ({ item, ...props }) => {

    const { content } = item;
    const { reducer } = useSelector((state) => state);
    const { isSiteBuilder, pageJson } = reducer;
    const { title } = content || {};
    const fontFamily = pageJson?.pageStyle?.fontFamily || 'Roboto';
    const cardWidth = item?.props?.cardWidth || 'M';
    const fullBleed = Boolean(item?.props?.fullBleed);
    const contentAlignVertical = item?.props?.contentAlignVertical || 'center';
    const accentImage = item?.props?.accentImage;
    const maxWidth = CARD_WIDTH[cardWidth] ?? CARD_WIDTH.M;

    return (
        <Card
            {...props}
            sx={{
                ...props.sx,
                position: 'relative',
                width: fullBleed ? "100%" : "100%",
                maxWidth: fullBleed ? "none" : maxWidth,
                borderRadius: "24px",
                textAlign: item?.props?.textAlign || "center",
                height: '100%',
                ...item?.props?.style,
                ...props.style
            }}
            onClick={() => {
                if (item?.url) {
                    if (typeof item?.url === "object") {
                        if (item?.url?.target) {
                            window.open(item?.url?.path, "_blank", "noopener,noreferrer");
                        } else {
                            window.location.href = item?.url?.path;
                        }
                    } else {
                        window.location.href = item?.url;
                    }
                }
            }}
        >
            {(accentImage && typeof accentImage === 'string') && (
                <Stack direction="row" justifyContent="flex-end" sx={{ position: 'absolute', top: 8, right: 8, zIndex: 1 }}>
                    <Box component="img" src={accentImage} alt="" sx={{ width: 48, height: 48, borderRadius: 1, objectFit: 'cover' }} />
                </Stack>
            )}
            <CardContent sx={{ p: fullBleed ? 0 : undefined }}>
                <Stack
                    spacing={1}
                    alignItems={item?.props?.alignItems || 'center'}
                    justifyContent={contentAlignVertical === 'top' ? 'flex-start' : contentAlignVertical === 'bottom' ? 'flex-end' : 'center'}
                    sx={{ minHeight: fullBleed ? undefined : 80, p: fullBleed ? 0 : undefined }}
                >
                    {title && (() => {
                        const { backgroundColor, borderColor, borderWidth, borderStyle, ...titleStyle } = item?.props?.style || {};
                        return <Typography data-sb-field="title" sx={{ ...titleStyle, color: titleStyle.color ? `${titleStyle.color}!important` : undefined, fontFamily: `${fontFamily}!important` }}>{title}</Typography>;
                    })()}
                    {content?.content && <Typography data-sb-field="content" variant="body2" sx={{ ...item?.props?.style2, color: item?.props?.style2?.color ? `${item?.props?.style2?.color}!important` : undefined, fontFamily: `${fontFamily}!important` }}>{content?.content}</Typography>}
                </Stack>
            </CardContent>
        </Card>
    );
};

export default CustomCardComponent;
